import React, { useContext, useEffect, useState, useRef } from 'react';
import { MenuList } from '@/components/menuList';
import { Text, Flex, Icon, Menu, MenuButton, MenuItem, IconButton, useDisclosure, Box, Button, Tooltip } from '@chakra-ui/react';
import { MdArrowForward, MdArrowOutward, MdDevices, MdDragIndicator, MdFace, MdMoreVert, MdOutlineDelete, MdOutlineLayers, MdOutlineLayersClear, MdOutlineRoute } from 'react-icons/md';
import InsightTags from '@/insight/components/insightTags';
import { Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay } from '@chakra-ui/modal';
import PersonaProvider from '@/persona/lib/personaProvider';
import PersonaThumbnail from '@/persona/components/personaThumbnail';
import ProductLogo from '@/products/components/productLogo';
import ProductProvider from '@/products/lib/productProvider';
import { Link, useNavigate } from 'react-router-dom';
import SharedExperienceTag from '@/components/sharedExperienceTag';
import { useSharedExperiencesApi } from '../../lib/useSharedExperiencesApi';
import { SharedExperiencesContext } from '../../lib/sharedExperiencesProvider';
import { SharedExperiencePageContext } from '../lib/sharedExperiencePageContext';
import MoveExperienceInSharedExperienceToGroupForm from './moveExperienceInSharedExperienceToGroupForm';
import useTranslation from '../../../lib/i18n/useTranslation';

export default function ExperiencesInSharedExperienceListItem(props) {
  const { t } = useTranslation();
  const {
    refreshExperienceList,
    experienceGroupList,
    parentGroup,
  } = useContext(SharedExperiencePageContext);
  const {
    data,
  } = props;
  
  const {
    sharedExperienceId,
    rights,
  } = useContext(SharedExperiencesContext);
  const [isDeleting, setIsDeleting] = useState(false);
  const [productList, setProductList] = useState(false);
  const [personaList, setPersonaList] = useState(false);
  const [isAdding, setIsAdding] = useState(false);
  const [isValid, setIsValid] = useState(false);
  const navigate = useNavigate();
  const modalMoveToGroup = useDisclosure();
  const ref1 = useRef();
  const sharedExperiencesApi = useSharedExperiencesApi();
  const removeExperienceFromSharedExperience = async () => {
    try {
      setIsDeleting(true);
      
      const relationId = data?.id || data?.experiences_shared_experiences_id;
      if (!relationId) {
        console.error('❌ Error: No valid relation ID found for experience removal', data);
        setIsDeleting(false);
        return;
      }
      
      await sharedExperiencesApi.removeExperienceFromSharedExperience(sharedExperienceId, relationId);
      await refreshExperienceList()
      setIsDeleting(false);
    } catch (e) {
      console.error('❌ Error in removeExperienceFromSharedExperience:', e);
      setIsDeleting(false);
    }
  }
  const leaveTheGroup = async () => {
    try {

      await sharedExperiencesApi.moveExperienceToGroup(
        sharedExperienceId,
        data.id,
        parentGroup?.group_id ?? null
      );
      await refreshExperienceList();
      navigate(`/shared-experiences/${sharedExperienceId}?group-id=${parentGroup?.id || ''}`);
    } catch (error) {
      console.error(error);
    }
  }
  useEffect(() => {
    if (data) {
      if (data.personas && data.personas[0] !== null) {
        setPersonaList(data.personas)
      }
      if (data.products && data.products[0] !== null) {
        setProductList(data.products)
      }
    }
  }, [data]);
  return (
    <>
      <Flex
        px={3}
        py={2}
        backgroundColor="white"
        role={'group'}
        _hover={{
          background: "background.grey",
        }}
        position={"relative"}
        height={"90px"}
        cursor={"pointer"}
      >
        {rights.can_update && (
          <Flex
            position={"absolute"}
            top="0"
            left={"0"}
            height={"100%"}
            opacity={0}
            _groupHover={{ opacity: '1' }}
            cursor={"grab"}
            py={2}
            pr={3}
          >
            <Icon
              as={MdDragIndicator}
              boxSize={'20px'}
              color={"text.light.grey"}
              mr={2}
            />
          </Flex>
        )}
        <Flex
          flex={1}
          alignItems={"flex-start"}
          justifyContent={"space-between"}
        >
          <Flex
            flexDirection={"column"}
            flex={1}
          >
            <Flex
              alignItems={"center"}
              mb={1}
            >
              <Icon
                as={MdOutlineRoute}
                boxSize={'15px'}
                mr={2}
              />
              <Text noOfLines={2} >
                {data?.experience?.objective || data?.objective || 'NO OBJECTIVE FOUND'}
              </Text>
            </Flex>
            {(data?.is_imported || (!data?.is_imported && data?.shared_experience_name)) && (
              <Flex mb={1}>
                <SharedExperienceTag 
                  sharedExperienceName={data?.shared_experience_name} 
                  size="sm"
                />
              </Flex>
            )}
          </Flex>
          {(() => {
            return data.insights_count && (
              <InsightTags
                nbPostiveFeedback={data.insights_count?.positive_count || 0}
                nbNegativeFeedback={data.insights_count?.negative_count || 0}
                nbImprovementFeedback={data.insights_count?.improvement_count || 0}
                nbBehavior={data.insights_count?.behavior_count || 0}
                nbMotivation={data.insights_count?.motivation_count || 0}
              />
            );
          })()}
        </Flex>
          <Flex
            height={"100%"}
            pl={3}
            alignItems={"center"}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
          >
          {(!rights.can_update) &&
            <IconButton
               icon={<MdArrowForward />}
               fontSize={"18px"}
               size="md"
               variant='greyTransparent'
               opacity={"0"}
               _groupHover={{ opacity: '1' }}
               onClick={(e) => {
                 navigate(`/experiences/${data.id}`, { replace: true });
               }}
             />
          }
            {rights.can_update &&
              <Menu >
                {({ isOpen }) => (
                  <>
                    <MenuButton
                      isActive={isOpen}
                      as={IconButton}
                      icon={<MdMoreVert />}
                      fontSize={"18px"}
                      size="md"
                      variant='greyTransparent'
                    />
                      <MenuList zIndex="popover">
                        <MenuItem onClick={(e) => {
                          navigate(`/experiences/${data.id}`, { replace: true });
                        }} >
                          <Icon as={MdArrowForward} mr={2} color="text.medium.dark" />
                          <Text color="text.medium.dark">{t('experience.goToExperience')}</Text>
                        </MenuItem>
                        {(experienceGroupList && experienceGroupList.length > 0) && !data.source_shared_experiences_id &&
                          <MenuItem onClick={modalMoveToGroup.onOpen} >
                            <Icon as={MdArrowOutward} mr={2} color="text.medium.dark" />
                            <Text color="text.medium.dark">{t('group.moveToGroup')}</Text>
                          </MenuItem>
                        }
                        {data?.group_id &&
                          <MenuItem
                            onClick={leaveTheGroup}
                          >
                            <Icon as={MdArrowOutward} mr={2} color="text.medium.dark" />
                            <Text color="text.medium.dark">{t('experience.leaveGroup')}</Text>
                          </MenuItem>
                        }
                        {!data.shared_experiences?.id && (
                          <MenuItem
                            onClick={removeExperienceFromSharedExperience}
                            color={"text.medium.red"}
                          >
                            <Icon as={MdOutlineDelete} mr={2} color="text.medium.red" />
                            <Text color="text.medium.red">{t('sharedExperience.removeFromSharedExperience')}</Text>
                          </MenuItem>
                        )}
                      </MenuList>
                  </>
                )}
              </Menu>
            }
          </Flex>
        <Modal
          isOpen={modalMoveToGroup.isOpen}
          onClose={modalMoveToGroup.onClose}
        >
          <ModalOverlay />
          <ModalContent >
            <ModalHeader>{t('group.moveToGroup')}</ModalHeader>
            <ModalBody >
              <Box p={3}>
                <MoveExperienceInSharedExperienceToGroupForm
                  experienceId={data?.experience?.id}
                  data={data}
                  hideSave={true}
                  onValidityChange={setIsValid}
                  onSubmitting={() => {
                    setIsAdding(true);
                  }}
                  onSubmitted={() => {
                    setIsAdding(false);
                    refreshExperienceList();
                    modalMoveToGroup.onClose();
                  }}
                  ref={ref1}
                />
              </Box>
            </ModalBody>
            <ModalFooter>
              <Button
                variant='greenOutline'
                onClick={modalMoveToGroup.onClose}
              >{t('common.cancel')}</Button>
              <Button
                variant="greenFill"
                ml={2}
                isLoading={isAdding}
                isDisabled={!isValid}
                onClick={() => {
                  ref1.current.click();
                }}>{t('common.save')}</Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </Flex >
    </>
  );
} 